import { EntraIdUserExportAliasHandling, EntraIdUserExportSettingBehaviour, EntraIdUserExportUserPrincipalNameSource, EntraIdUserExportPasswordSettingType, EntraIdUserExportPasswordCharacterSet, EntraIdUserExportPrimaryEmailAddressSource, 
    EntraIdUserExportUserType, EntraIdUserExportCompanyNameSource, EntraIdUserExportDepartmentSource, EntraIdUserExportEmployeeIdSource, EntraIdUserExportEmployeeTypeSource, EntraIdUserExportJobTitleSource, 
    EntraIdUserExportExtensionsSource} from '../../../../../../models/CoreEntraIdUserModels';


export const passwordTypeOptions: EntraIdUserExportPasswordSettingType[] = [
    EntraIdUserExportPasswordSettingType.STATIC,
    EntraIdUserExportPasswordSettingType.RANDOM,
]

export const passwordCharacterSetSelectionOptions: EntraIdUserExportPasswordCharacterSet[] = [
    EntraIdUserExportPasswordCharacterSet.UPPER_CASE_LETTERS,
    EntraIdUserExportPasswordCharacterSet.LOWER_CASE_LETTERS,
    EntraIdUserExportPasswordCharacterSet.NUMBERS,
    EntraIdUserExportPasswordCharacterSet.SPECIAL_CHARACTERS,
]

export const ExportPrimaryEmailAddressSource: EntraIdUserExportPrimaryEmailAddressSource[] = [
    EntraIdUserExportPrimaryEmailAddressSource.FLOW_SYNC_EMAIL_ADDRESS,
    EntraIdUserExportPrimaryEmailAddressSource.COPY_USER_PRINCIPAL_NAME,
    EntraIdUserExportPrimaryEmailAddressSource.GENERATED
]

export const ExportSettingsBehaviour: EntraIdUserExportSettingBehaviour[] = [
     EntraIdUserExportSettingBehaviour.SET_ONCE,
     EntraIdUserExportSettingBehaviour.FORCE,
     EntraIdUserExportSettingBehaviour.ALLOW_CHANGE
]

export const ExportAliasHandling: EntraIdUserExportAliasHandling[] = [
    EntraIdUserExportAliasHandling.SET_OLD_AS_ALIAS,
    EntraIdUserExportAliasHandling.SET_NEW_AS_ALIAS
]

export const ExportUserPrincipalNameSource: EntraIdUserExportUserPrincipalNameSource[] = [
    EntraIdUserExportUserPrincipalNameSource.FLOW_SYNC_EMAIL_ADDRESS,
    EntraIdUserExportUserPrincipalNameSource.GENERATED
]

export const userTypeOptions: EntraIdUserExportUserType[] = [
    EntraIdUserExportUserType.STUDENT,
    EntraIdUserExportUserType.STAFF
]

export const companyNameSourceOptions: EntraIdUserExportCompanyNameSource[] = [
    EntraIdUserExportCompanyNameSource.NONE,
    EntraIdUserExportCompanyNameSource.PRIMARY_SCHOOL_UNIT_NAME,
    EntraIdUserExportCompanyNameSource.CONSTANT_VALUE
]

export const departmentNameSourceOptions: EntraIdUserExportDepartmentSource[] = [
    EntraIdUserExportDepartmentSource.NONE,
    EntraIdUserExportDepartmentSource.PRIMARY_SCHOOL_UNIT_NAME,
    EntraIdUserExportDepartmentSource.CONSTANT_VALUE
]

export const employeeIdSourceOptions: EntraIdUserExportEmployeeIdSource[] = [
    EntraIdUserExportEmployeeIdSource.NONE,
    EntraIdUserExportEmployeeIdSource.CIVIC_NO
]

export const employeeTypeSourceOptions: EntraIdUserExportEmployeeTypeSource[] = [
    EntraIdUserExportEmployeeTypeSource.NONE,
    EntraIdUserExportEmployeeTypeSource.ROLE_BASED
]

export const jobTitleSourceOptions: EntraIdUserExportJobTitleSource[] = [
    EntraIdUserExportJobTitleSource.NONE,
    EntraIdUserExportJobTitleSource.ROLE_BASED
]

export const EntraIdUserExportExtensionsSourceOptions: EntraIdUserExportExtensionsSource[] = [
    EntraIdUserExportExtensionsSource.CivicNo,
    EntraIdUserExportExtensionsSource.Eppn
]
